interface AvatarSwatch {
    readonly fill: string;
    /** People use the light/ink design tokens; Perspective and responder initials use solid text. */
    readonly peopleInitial: "light" | "ink";
    readonly text: "var(--color-white)" | "var(--color-black)";
}

const SWATCHES = {
    ISTJ: { fill: "#2fa39c", peopleInitial: "light", text: "var(--color-black)" },
    ISFJ: { fill: "#b92a6a", peopleInitial: "light", text: "var(--color-white)" },
    INFJ: { fill: "#3f8060", peopleInitial: "light", text: "var(--color-white)" },
    INTJ: { fill: "#5852c4", peopleInitial: "light", text: "var(--color-white)" },
    ISTP: { fill: "#fbb877", peopleInitial: "ink", text: "var(--color-black)" },
    ISFP: { fill: "#f2766a", peopleInitial: "light", text: "var(--color-black)" },
    INFP: { fill: "#5fa37c", peopleInitial: "light", text: "var(--color-black)" },
    INTP: { fill: "#7e78de", peopleInitial: "light", text: "var(--color-black)" },
    ESTP: { fill: "#ffd3a8", peopleInitial: "ink", text: "var(--color-black)" },
    ESFP: { fill: "#fb9a5e", peopleInitial: "light", text: "var(--color-black)" },
    ENFP: { fill: "#bbe3b4", peopleInitial: "ink", text: "var(--color-black)" },
    ENTP: { fill: "#c6d6f6", peopleInitial: "ink", text: "var(--color-black)" },
    ESTJ: { fill: "#84d6d0", peopleInitial: "ink", text: "var(--color-black)" },
    ESFJ: { fill: "#e84c8e", peopleInitial: "light", text: "var(--color-black)" },
    ENFJ: { fill: "#8ac79b", peopleInitial: "ink", text: "var(--color-black)" },
    ENTJ: { fill: "#ada8ee", peopleInitial: "light", text: "var(--color-black)" },
} as const satisfies Record<string, AvatarSwatch>;

// Preserve type-map insertion order and uppercase values for existing wheel/badge consumers.
export const TYPE_COLORS: Record<string, string> = Object.fromEntries(Object.entries(SWATCHES).map(([type, swatch]) => [type, swatch.fill.toUpperCase()]));

// Changing this order recolours existing people and anonymous responder badges.
const IDENTITY_ORDER = ["INTJ", "ISTP", "ISTJ", "ESFJ", "INFP", "INTP", "ESFP", "ESTJ", "ISFJ", "INFJ", "ENTJ", "ESTP", "ISFP", "ENFJ", "ENTP", "ENFP"] as const;
const IDENTITY_SWATCHES = IDENTITY_ORDER.map((type) => SWATCHES[type]);

export function getPerspectiveSwatch(letters: string | null | undefined): AvatarSwatch | null {
    if (!letters || !Object.hasOwn(SWATCHES, letters)) {
        return null;
    }
    return SWATCHES[letters as keyof typeof SWATCHES];
}

export function getIndexedAvatarSwatch(index: number): AvatarSwatch {
    return IDENTITY_SWATCHES[index % IDENTITY_SWATCHES.length];
}

/** Preserve the existing name-to-colour mapping; this does not indicate a Perspective type. */
export function getPeopleAvatarSwatch(name: string): AvatarSwatch {
    let hash = 0;
    for (const char of name) {
        hash = (hash * 31 + char.codePointAt(0)!) % IDENTITY_SWATCHES.length ** 3;
    }
    return getIndexedAvatarSwatch(hash);
}
